module.exports = __webpack_public_path__ + "img/bg7.de49286b.jpg";